import { STRIPE_PAYMENT_INTENT, STRIPE_PAYMENT_STATUS } from '@gameday/common/constants/endpoints'

export default {
  createPaymentIntent: STRIPE_PAYMENT_INTENT,
  getPaymentStatus: STRIPE_PAYMENT_STATUS,
}
